<!-- Forgot password reset (code + new password) view -->
<section class="form-group" [ngClass]="{ 'd-none': loading }">
  <article
    [ngClass]="theme.getThemeClass()"
    class="wrapper fadeInDown wrapperAdds"
  >
    <img class="logo" src="../assets/muirwood-studio.png" />
    <h2 class="text-center">
      {{ "loginForgotPasswordCreateNewPW" | translate }}
    </h2>
    <p>{{ "loginForgotPasswordFillFields" | translate }}</p>
    <form
      (ngSubmit)="ctx.submitPasswordReset()"
      id="register-form"
      role="form"
      autocomplete="off"
      class="form resetWithCodeView"
      method="post"
    >
      <!-- Input section -->
      <input
        type="text"
        id="resetCode"
        [(ngModel)]="ctx.resetCode"
        class="form-control"
        name="resetCode"
        autocomplete="one-time-code"
        placeholder="{{ 'loginForgotPasswordPlaceHolder' | translate }}"
        required
        minlength="1"
        #userCode="ngModel"
      />
      <input
        type="{{ ctx.showPassword ? 'text' : 'password' }}"
        id="password"
        [(ngModel)]="ctx.resetNewPassword"
        class="form-control"
        name="resetNewPassword"
        autocomplete="new-password"
        placeholder="{{ 'loginForgotPasswordPlaceHolderNewPW' | translate }}"
        required
        minlength="1"
        #requestPassword="ngModel"
        (input)="ctx.validatePasswordInput(ctx.resetNewPassword, true)"
      />
      @if (ctx.showAlertStrong) {
      <div class="colorGreen">
        {{ "loginFNewPasswordAlertStrongPassword" | translate }}
      </div>
      } @if (ctx.showAlertWeak) {
      <div class="colorRed">
        {{ "loginFNewPasswordAlertWeakPassword" | translate }}
      </div>
      }
      <a>
        @if (ctx.showCheckBoxTipResetPw) {
        <div [ngClass]="theme.getThemeClass()" class="popup">
          <label>{{
            "loginFNewPasswordLabelPasswordRequirements" | translate
          }}</label
          ><br />
          <!-- IMG check or oncheck section for password wikeness-->
          <nav class="centered-container">
            @if (!ctx.charactersChecked) {
            <img
              id="noChecked"
              src="assets/iconchecked.png"
              alt="dinamicCheckBox"
              class="checkSymbol"
            />
            } @else {
            <img
              id="noChecked"
              src="assets/icochecked.png"
              alt="dinamicCheckBox"
              class="checkSymbol"
            />
            }
            <span>{{
              "loginFNewPasswordPasswordRequirementsCharQtt" | translate
            }}</span>
          </nav>
          <nav [ngClass]="theme.getThemeClass()" class="centered-container">
            @if (!ctx.lowerCaseChecked) {
            <img
              id="noChecked"
              src="assets/iconchecked.png"
              alt="dinamicCheckBox"
              class="checkSymbol"
            />
            } @else {
            <img
              id="noChecked"
              src="assets/icochecked.png"
              alt="dinamicCheckBox"
              class="checkSymbol"
            />
            }
            <span>{{
              "loginFNewPasswordPasswordRequirementsOneLowercaseLetter"
                | translate
            }}</span>
          </nav>
          <nav [ngClass]="theme.getThemeClass()" class="centered-container">
            @if (!ctx.upperCaseChecked) {
            <img
              id="noChecked"
              src="assets/iconchecked.png"
              alt="dinamicCheckBox"
              class="checkSymbol"
            />
            } @else {
            <img
              id="noChecked"
              src="assets/icochecked.png"
              alt="dinamicCheckBox"
              class="checkSymbol"
            />
            }
            <span>{{
              "loginFNewPasswordPasswordRequirementsOneUppercaseLetter"
                | translate
            }}</span>
          </nav>
          <nav [ngClass]="theme.getThemeClass()" class="centered-container">
            @if (!ctx.oneDigitChecked) {
            <img
              id="noChecked"
              src="assets/iconchecked.png"
              alt="dinamicCheckBox"
              class="checkSymbol"
            />
            } @else {
            <img
              id="noChecked"
              src="assets/icochecked.png"
              alt="dinamicCheckBox"
              class="checkSymbol"
            />
            }
            <span>{{
              "loginFNewPasswordPasswordRequirementsOneDigit" | translate
            }}</span>
          </nav>
          <nav [ngClass]="theme.getThemeClass()" class="centered-container">
            @if (!ctx.specialCharChecked) {
            <img
              id="noChecked"
              src="assets/iconchecked.png"
              alt="dinamicCheckBox"
              class="checkSymbol"
            />
            } @else {
            <img
              id="noChecked"
              src="assets/icochecked.png"
              alt="dinamicCheckBox"
              class="checkSymbol"
            />
            }
            <span>{{
              "loginFNewPasswordPasswordRequirementsOneSpecialChar"
                | translate
            }}</span>
          </nav>
        </div>
        }
        <!-- End of IMG check or oncheck section for password wikeness-->
        <nav [ngClass]="theme.getThemeClass()" class="btn">
          <input
            class="inputBtn"
            name="recover-submit"
            value="{{ 'loginForgotSubmit' | translate }}"
            type="submit"
          />
        </nav>
      </a>
    </form>
  </article>
</section>
